function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { isNull, orderBy } from 'lodash';
import { makeAutoObservable } from 'mobx';
import userApi from '../api/userApi';
import { User } from '../models/User';
import { getDisplayNames } from '../models/Builder';
import builderApi from '../api/builderApi';
export var UserStore = /*#__PURE__*/ function() {
    "use strict";
    function UserStore() {
        var _this = this;
        _class_call_check(this, UserStore);
        _define_property(this, "isLoading", true);
        _define_property(this, "searchTerm", '');
        _define_property(this, "users", []);
        _define_property(this, "user", new User());
        _define_property(this, "companies", []);
        _define_property(this, "builders", []);
        _define_property(this, "fetchAll", function() {
            return _async_to_generator(function() {
                var r, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                3,
                                4
                            ]);
                            this.setIsLoading(true);
                            return [
                                4,
                                userApi.users.getAll()
                            ];
                        case 1:
                            r = _state.sent();
                            this.setUsers(r.data);
                            return [
                                3,
                                4
                            ];
                        case 2:
                            error = _state.sent();
                            console.error(error);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            this.setIsLoading(false);
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }).call(_this);
        });
        _define_property(this, "fetchById", function(userId) {
            return _async_to_generator(function() {
                var r, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                3,
                                4
                            ]);
                            this.setIsLoading(true);
                            return [
                                4,
                                userApi.users.getById(userId)
                            ];
                        case 1:
                            r = _state.sent();
                            this.setUser(r.data);
                            return [
                                3,
                                4
                            ];
                        case 2:
                            error = _state.sent();
                            console.error(error);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            this.setIsLoading(false);
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }).call(_this);
        });
        _define_property(this, "update", function(user) {
            return _async_to_generator(function() {
                var r, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                3,
                                4
                            ]);
                            this.setIsLoading(true);
                            isNull(user.securityGroups) && (user.securityGroups = []);
                            return [
                                4,
                                userApi.users.update(user)
                            ];
                        case 1:
                            r = _state.sent();
                            this.setUser(r.data);
                            return [
                                3,
                                4
                            ];
                        case 2:
                            error = _state.sent();
                            console.error(error);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            this.setIsLoading(false);
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }).call(_this);
        });
        _define_property(this, "fetchAllCompanies", function() {
            return _async_to_generator(function() {
                var r, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                3,
                                4
                            ]);
                            this.setIsLoading(true);
                            return [
                                4,
                                userApi.companies.getAll()
                            ];
                        case 1:
                            r = _state.sent();
                            this.setCompanies(orderBy(r.data, [
                                function(company) {
                                    return company.name.toLowerCase();
                                }
                            ]));
                            return [
                                3,
                                4
                            ];
                        case 2:
                            error = _state.sent();
                            console.error(error);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            this.setIsLoading(false);
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            }).call(_this);
        });
        _define_property(this, "fetchAllBuilders", function() {
            return _async_to_generator(function() {
                var builders, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                builderApi.builders.getAll()
                            ];
                        case 1:
                            builders = _state.sent().data.content;
                            getDisplayNames(builders);
                            this.setBuilders(orderBy(builders, [
                                function(builder) {
                                    return builder.name.toLowerCase();
                                }
                            ]));
                            return [
                                2,
                                this.builders
                            ];
                        case 2:
                            error = _state.sent();
                            console.error(error);
                            return [
                                2,
                                []
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            }).call(_this);
        });
        makeAutoObservable(this);
    }
    _create_class(UserStore, [
        {
            key: "filteredUsers",
            get: function get() {
                var _this = this;
                return this.users.filter(function(user) {
                    var _user_company;
                    return user.username.toLowerCase().includes(_this.searchTerm.toLowerCase()) || ((_user_company = user.company) === null || _user_company === void 0 ? void 0 : _user_company.name.toLowerCase().includes(_this.searchTerm.toLowerCase()));
                });
            }
        },
        {
            key: "setUsers",
            value: function setUsers(value) {
                this.users = value;
            }
        },
        {
            key: "setIsLoading",
            value: function setIsLoading(value) {
                this.isLoading = value;
            }
        },
        {
            key: "setSearchTerm",
            value: function setSearchTerm(value) {
                this.searchTerm = value;
            }
        },
        {
            key: "setUser",
            value: function setUser(value) {
                this.user = value;
            }
        },
        {
            key: "setCompanies",
            value: function setCompanies(value) {
                this.companies = value;
            }
        },
        {
            key: "setBuilders",
            value: function setBuilders(value) {
                this.builders = value;
            }
        }
    ]);
    return UserStore;
}();
